import * as React from "react";
import { useWindowDimensions } from "react-native";
import { createDrawerNavigator } from "@react-navigation/drawer";
import { drawerItemsMain } from "./ChinaTrackerDrawerItemsMain ";
import CustomDrawerContent from "../../../components/custom/CustomDrawerContent";
import ChinaTrackerScreen from "../../../screens/ChinaTracker/ChinaTrackerScreen";
import ChinaTrackerDetailsReport from "../../../screens/ChinaTracker/partials/ChinaTrackerDetailsReport";
import { useTranslation } from "../../../utils/useTranslation";
import ChinaShipmentScreen from "../../../screens/ChinaShipment/ChinaShipmentScreen";
import ChinaShipmentDetailsReport from "../../../screens/ChinaShipment/partials/ChinaShipmentDetailsReport";
import ChinaGlobalShipment from "../../../screens/ChinaShipment/ChinaGlobalShipment";
import GlobalShipmentDetailsReport from "../../../screens/ChinaShipment/global/GlobalShipmentDetailsReport";
import { useAppTheme } from "../../../hooks/useAppTheme";


const Drawer = createDrawerNavigator();

export default function ChinaTrackerDrawerNavigator() {
  const { colors } = useAppTheme();
  const dimensions = useWindowDimensions();
  const { t } = useTranslation();

  const translatedItems = drawerItemsMain
    .filter((item: any) => {
      if (item.key === "GlobalShipment") {
        return process.env.NODE_ENV !== "production";
      }
      return true;
    })
    .map((item: any) => {
      let translatedTitle = item.title;
      let translatedRoutes = [...item.routes];

      if (item.key === "ChinaTracker") {
        translatedTitle = t("chinaOrderTracker");
        translatedRoutes[0].title = t("chinaOrderTracker");
      } else if (item.key === "ChinaShipment") {
        translatedTitle = t("chinaShipment");
        translatedRoutes[0].title = t("chinaShipment");
      } else if (item.key === "GlobalShipment") {
        translatedTitle = t("globalShipment");
        translatedRoutes[0].title = t("globalShipment");
      }

      return {
        ...item,
        title: translatedTitle,
        routes: translatedRoutes,
      };
    });
  return (
    <Drawer.Navigator
      screenOptions={{
        headerTintColor: colors.text,
        headerStyle: {
          backgroundColor: colors.surface,
          borderBottomWidth: 1,
          borderBottomColor: colors.border,
        },
        headerTitleStyle: {
          color: colors.text,
        },
        tabBarStyle: {
          backgroundColor: colors.surface,
          borderTopColor: colors.border,
        },
        drawerStyle: {
          width: 200,
        },
        drawerLabelStyle: {
          fontSize: 12,
          textTransform: "none",
        },
        drawerType: dimensions.width >= 768 ? "front" : "front", //'permanent' : 'front',
      }}
      drawerContent={(props) => (
        <CustomDrawerContent drawerItems={translatedItems} {...props} />
      )}
    >
      <Drawer.Screen
        options={{
          drawerLabel: t("chinatracker"),
          title: t("chinaOrderTracker"),
        }}
        name="ChinaTrackerReport"
        component={ChinaTrackerScreen}
      />

      <Drawer.Screen
        options={{
          drawerLabel: t("chinatrackerdetailsreport"),
          title: t("chinaOrderTracker"),
        }}
        name="ChinaTrackerDetailsReport"
        component={ChinaTrackerDetailsReport}
      />

      <Drawer.Screen
        options={{
          drawerLabel: t("chinashipment"),
          title: t("chinaShipment"),
        }}
        name="ChinaShipmentReport"
        component={ChinaShipmentScreen}
      />

      {process.env.NODE_ENV !== "production" && (
        <Drawer.Screen
          options={{
            drawerLabel: t("globalshipment"),
            title: t("globalShipment"),
          }}
          name="GlobalShipmentReport"
          component={ChinaGlobalShipment}
        />
      )}

      <Drawer.Screen
        options={{
          drawerLabel: t("chinashipmentdetailsreport"),
          title: t("chinaShipmentDetailsReport"),
        }}
        name="ChinaShipmentDetailsReport"
        component={ChinaShipmentDetailsReport}
      />

      <Drawer.Screen
        options={{
          drawerLabel: t("globalshipmentdetailsreport"),
          title: t("globalShipmentDetailsReport"),
        }}
        name="GlobalShipmentDetailsReport"
        component={GlobalShipmentDetailsReport}
      />
    </Drawer.Navigator>
  );
}
